<div class="sidebar-filters" [class.collapsed]="isCollapsed">
  <!-- Header con botón de colapsar -->
  <div class="filters-header">
    <h3 class="filters-title">
      <i class="fas fa-filter"></i>
      Filtros
      <span class="active-filters-badge" *ngIf="hasActiveFilters()">●</span>
    </h3>
    <button class="collapse-btn" (click)="toggleCollapse()" type="button">
      <i [class]="isCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
    </button>
  </div>

  <!-- Contenido de filtros -->
  <div class="filters-content" [class.hidden]="isCollapsed">

    <!-- Búsqueda por texto -->
    <div class="filter-section">
      <label class="filter-label">
        <i class="fas fa-search"></i>
        Buscar
      </label>
      <input
        type="text"
        class="filter-input"
        [(ngModel)]="filters.searchText"
        (input)="onSearchTextChange()"
        placeholder="Título, descripción, autor..."
        autocomplete="off">
    </div>


    <!-- Subcategorías -->
    <div class="filter-section" *ngIf="subCategories.length > 0">
      <label class="filter-label">
        <i class="fas fa-tags"></i>
        Subcategoría
      </label>
      <select
        class="filter-select"
        [(ngModel)]="filters.subCategory"
        (change)="onSubCategoryChange()">
        <option value="">Todas las subcategorías</option>
        <option *ngFor="let subCat of subCategories" [value]="subCat.name">
          {{ subCat.descript }}
        </option>
      </select>
    </div>

    <!-- Ordenamiento -->
    <div class="filter-section">
      <label class="filter-label">
        <i class="fas fa-sort"></i>
        Ordenar por
      </label>
      <select
        class="filter-select"
        [(ngModel)]="filters.sortBy"
        (change)="onSortByChange()">
        <option *ngFor="let option of sortOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- Rango de años -->
    <div class="filter-section">
      <label class="filter-label">
        <i class="fas fa-calendar-alt"></i>
        Rango de años
      </label>
      <div class="year-range">
        <span class="year-display">{{ filters.yearFrom }} - {{ filters.yearTo }}</span>
        <div class="slider-container">
          <input
            type="range"
            class="year-slider"
            [min]="minYear"
            [max]="maxYear"
            [(ngModel)]="filters.yearFrom"
            (input)="onYearRangeChange()">
          <input
            type="range"
            class="year-slider year-slider-to"
            [min]="minYear"
            [max]="maxYear"
            [(ngModel)]="filters.yearTo"
            (input)="onYearRangeChange()">
        </div>
        <div class="year-inputs">
          <input
            type="number"
            class="year-number-input"
            [(ngModel)]="filters.yearFrom"
            [min]="minYear"
            [max]="maxYear"
            (change)="onYearRangeChange()"
            placeholder="Desde">
          <input
            type="number"
            class="year-number-input"
            [(ngModel)]="filters.yearTo"
            [min]="minYear"
            [max]="maxYear"
            (change)="onYearRangeChange()"
            placeholder="Hasta">
        </div>
      </div>
    </div>

    <!-- Rango de fechas exactas -->
    <div class="filter-section">
      <label class="filter-label">
        <i class="fas fa-calendar-week"></i>
        Fechas exactas
      </label>
      <div class="date-range">
        <input
          type="date"
          class="filter-input date-input"
          [(ngModel)]="filters.dateFrom"
          (change)="onDateRangeChange()"
          placeholder="Desde">
        <input
          type="date"
          class="filter-input date-input"
          [(ngModel)]="filters.dateTo"
          (change)="onDateRangeChange()"
          placeholder="Hasta">
      </div>
    </div>

    <!-- Botón de limpiar filtros -->
    <div class="filter-section">
      <button
        class="reset-btn"
        (click)="resetFilters()"
        [disabled]="!hasActiveFilters()"
        type="button">
        <i class="fas fa-undo"></i>
        Limpiar filtros
      </button>
    </div>
  </div>

</div>